import useIsMobile from "@/hooks/useIsMobile";
import CategoryPage from "@/screens/StaticCategory";
import PageLayout from "@/screens/Layout/PageLayout";

export default function Category({
  categoryNewsListData = null,
  statesData = null,
  latestStoryData = null,
  latestVideoData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <CategoryPage
          categoryNewsListData={null}
          statesData={statesData}
          isMobileDevice={isMobileDevice}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];

    const { getLatestContentFeed } = await import(
      "@/handlers/content"
    );

    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let UPDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/uttar-pradesh",
        page: page,
        display: 12,
        type: "all",
      },
    });
    let MPDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/madhya-pradesh",
        page: page,
        display: 12,
        type: "all",
      },
    });

    let RJDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/rajasthan",
        page: page,
        display: 12,
        type: "all",
      },
    });

    let BHDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/bihar",
        page: page,
        display: 12,
        type: "all",
      },
    });

    let HRDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/haryana",
        page: page,
        display: 12,
        type: "all",
      },
    });
    let DLDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/delhi-news",
        page: page,
        display: 12,
        type: "all",
      },
    });
    let CGDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/chhattisgarh",
        page: page,
        display: 12,
        type: "all",
      },
    });
    let UKDataRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/uttarakhand",
        page: page,
        display: 12,
        type: "all",
      },
    });

    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let [upData, mpdata, rjdata, bhdata, hrdata,dldata,cgdata,ukdata, latestStoryData, latestVideoData] =
      await Promise.all([
        fetchRedisWrapper(UPDataRedisKey, () =>
          getDataByUrl({
            url: "/uttar-pradesh",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(MPDataRedisKey, () =>
          getDataByUrl({
            url: "/madhya-pradesh",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(RJDataRedisKey, () =>
          getDataByUrl({
            url: "/rajasthan",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(BHDataRedisKey, () =>
          getDataByUrl({
            url: "/bihar",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(HRDataRedisKey, () =>
          getDataByUrl({
            url: "/haryana",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(DLDataRedisKey, () =>
          getDataByUrl({
            url: "/delhi-news",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(CGDataRedisKey, () =>
          getDataByUrl({
            url: "/chhattisgarh",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(UKDataRedisKey, () =>
          getDataByUrl({
            url: "/uttarakhand",
            page: page,
            display: 12,
            type: "all",
          })
        ),
        
        fetchRedisWrapper(latestStoryRedisKey, () =>
          getLatestContentFeed({
            type: "story",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(latestVideoRedisKey, () =>
          getLatestContentFeed({
            type: "video",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
      ]);

    let headerCache = upData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl||300);
    let statesData = [
      upData,
      mpdata,
      rjdata,
      bhdata,
      hrdata,
      dldata,
      cgdata,
      ukdata
    ]
    return {
      props: {
        categoryNewsListData:null,
        statesData,
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
